import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

const fetchComments = async (applicationId: string) => {
  const { data, error } = await supabase
    .from("comments")
    .select("*, user:user_id(*)")
    .eq("application_id", applicationId)
    .order("created_at", { ascending: false })

  if (error) throw error

  return data || []
}

export const useCommentsQuery = (applicationId: string | undefined) => {
  return useQuery({
    queryKey: ["comments", applicationId],
    queryFn: () => fetchComments(applicationId!),
    enabled: !!applicationId,
  })
}

export const useAddComment = (applicationId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (comment: string) => {
      const { data, error } = await supabase
        .from("comments")
        .insert({
          application_id: applicationId,
          comment: comment.trim(),
        })
        .select()

      if (error) throw error
      return data?.[0] || null
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["comments", applicationId],
      })
    },
  })
}
